import { Image, Stack, Text } from "@bookingcom/bui-react";
import { IMAGE_STATIC_ASSETS_URL } from "../../constants";
import type { Airline } from "../../types";

type AirlineLogoProps = {
  airline: Airline;
};

export const AirlineLogo = ({ airline }: AirlineLogoProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap={3}>
      <Text variant="emphasized_1">{airline.name}</Text>
      <Image
        alt={airline.name}
        contentMode="fill"
        fallbackImagePadding="small"
        fallbackImage
        src={`${IMAGE_STATIC_ASSETS_URL}/data/airlines_logo/${airline.code}.png`}
        height={10}
        width={10}
      />
    </Stack>
  );
};
